import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = {
  key: 0,
  role: "alert",
  class: "field-error"
}
const _hoisted_3 = {
  key: 0,
  class: "notify-person-limit"
}
const _hoisted_4 = { class: "pax" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { for: "adults" }
const _hoisted_7 = ["onClick", "disabled"]
const _hoisted_8 = ["onUpdate:modelValue"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { for: "children" }
const _hoisted_11 = ["onClick", "disabled"]
const _hoisted_12 = ["onUpdate:modelValue"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 0,
  class: "inform-age"
}
const _hoisted_15 = { key: 1 }
const _hoisted_16 = ["name", "value", "onChange", "checked"]
const _hoisted_17 = { class: "center-wrapper mobile-nav" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EasyDrop = _resolveComponent("EasyDrop")!

  return (_openBlock(), _createBlock(_component_EasyDrop, {
    customClasses: 'travellers',
    isFullMobile: true,
    position: 'right',
    hasTopTip: true,
    customButtonClasses: 'easy-icon-people main-drop search-btn',
    isLocked: !_ctx.allChildrenHasAge || !_ctx.paxLimit(),
    onIsLockedFunction: _ctx.validateChildrenAges,
    buttonId: 'searchTravellersBtn',
    ref: "easyDrop"
  }, {
    buttonText: _withCtx(() => [
      (_ctx.adultsCount)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode(_toDisplayString(_ctx.adultsCount) + " " + _toDisplayString(_ctx.adultSinglePlural(_ctx.adultsCount)), 1)
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.childrenCount)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(" , " + _toDisplayString(_ctx.childrenCount) + " " + _toDisplayString(_ctx.childSinglePlural(_ctx.childrenCount)), 1)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    contentHeader: _withCtx(() => [
      (_ctx.pageTexts['searchbarPersonPickerInfoPopup'])
        ? (_openBlock(), _createBlock(_component_EasyDrop, {
            key: 0,
            dropdownType: 'tooltip',
            position: 'right'
          }, {
            content: _withCtx(() => [
              _createElementVNode("div", {
                class: "rte",
                innerHTML: _ctx.pageTexts['searchbarPersonPickerInfoPopup']
              }, null, 8, _hoisted_1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("p", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.pageTexts['searchbarPersonPickerHeadline']), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.pageTexts['searchbarPersonPickerSubheadline']) + " ", 1),
        (_ctx.childAgeMissing)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.pageTexts['searchbarPersonPickerLabelChildrenMissingAge']), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    content: _withCtx(() => [
      (_ctx.paxCount > 9)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.pageTexts['searchbarPersonPickerNotifyPersonLimitText']), 1))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayRooms, (room, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
          _createElementVNode("fieldset", _hoisted_4, [
            _createElementVNode("legend", null, [
              _createTextVNode(_toDisplayString(_ctx.pageTexts['hotelPageTravelOverviewLabelRoom']) + " " + _toDisplayString(index + 1) + " ", 1),
              (index > 0)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "delete-btn",
                    title: "Fjern værelse",
                    onClick: ($event: any) => (_ctx.deleteRoom(index))
                  }, null, 8, _hoisted_5))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.pageTexts['searchbarPersonPickerLabelAdults']), 1),
              _createElementVNode("button", {
                class: "round",
                onClick: ($event: any) => (_ctx.removeAdult(index)),
                disabled: room.adults.length < 2
              }, " - ", 8, _hoisted_7),
              _withDirectives(_createElementVNode("input", {
                id: "adults",
                type: "text",
                disabled: "",
                "onUpdate:modelValue": ($event: any) => ((room.adults.length) = $event)
              }, null, 8, _hoisted_8), [
                [_vModelText, room.adults.length]
              ]),
              _createElementVNode("button", {
                class: "round",
                onClick: ($event: any) => (_ctx.addAdult(index))
              }, "+", 8, _hoisted_9)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("label", _hoisted_10, [
                _createTextVNode(_toDisplayString(_ctx.pageTexts['searchbarPersonPickerLabelChildren']), 1),
                _createElementVNode("small", null, _toDisplayString(_ctx.pageTexts['searchbarPersonPickerLabelChildrenAge']), 1)
              ]),
              _createElementVNode("button", {
                class: "round",
                onClick: ($event: any) => (_ctx.removeChild(index)),
                disabled: room.children.length < 1
              }, " - ", 8, _hoisted_11),
              _withDirectives(_createElementVNode("input", {
                id: "children",
                type: "text",
                disabled: "",
                "onUpdate:modelValue": ($event: any) => ((room.children.length) = $event)
              }, null, 8, _hoisted_12), [
                [_vModelText, room.children.length]
              ]),
              _createElementVNode("button", {
                class: "round",
                onClick: ($event: any) => (_ctx.addChild(index))
              }, "+", 8, _hoisted_13)
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(room.children, (child, idx) => {
            return (_openBlock(), _createBlock(_component_EasyDrop, {
              key: idx,
              dropdownType: 'select',
              isAccordion: true,
              buttonId: 'btnRoom' + index + 'Child' + idx
            }, {
              buttonText: _withCtx(() => [
                _createElementVNode("span", null, [
                  _createTextVNode(_toDisplayString(_ctx.pageTexts['searchbarPersonPickerLabelChild']) + " " + _toDisplayString(idx + 1) + " ", 1),
                  _createElementVNode("small", null, _toDisplayString(_ctx.pageTexts['searchbarPersonPickerLabelChildReturnAge']), 1)
                ]),
                (child.age == null)
                  ? (_openBlock(), _createElementBlock("strong", _hoisted_14, _toDisplayString(_ctx.pageTexts['searchbarPersonPickerLabelChildrenInformAge']), 1))
                  : _createCommentVNode("", true),
                (child.age !== null)
                  ? (_openBlock(), _createElementBlock("strong", _hoisted_15, _toDisplayString(child.age) + " " + _toDisplayString(_ctx.pageTexts['hotelPagePersonalInformationStepLabelBirthdateYear']), 1))
                  : _createCommentVNode("", true)
              ]),
              content: _withCtx(() => [
                _createElementVNode("fieldset", null, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(18, (age) => {
                    return _createElementVNode("label", { key: age }, [
                      _createElementVNode("input", {
                        type: "radio",
                        name: 'child' + idx + 'age',
                        value: age - 1,
                        onChange: ($event: any) => (_ctx.updateChildAge(index, idx, age - 1)),
                        checked: age - 1 === child.age
                      }, null, 40, _hoisted_16),
                      _createElementVNode("span", null, _toDisplayString(age - 1), 1)
                    ])
                  }), 64))
                ])
              ]),
              _: 2
            }, 1032, ["buttonId"]))
          }), 128))
        ], 64))
      }), 128)),
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addRoom && _ctx.addRoom(...args)))
      }, "+ " + _toDisplayString(_ctx.pageTexts['searchbarPersonPickerLabelAddAnotherRoom']), 1)
    ]),
    contentFooter: _withCtx(() => [
      _createElementVNode("div", _hoisted_17, [
        (_ctx.isHotelApp)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn-primary",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.searchTravel && _ctx.searchTravel(...args)))
            }, _toDisplayString(_ctx.pageTexts['searchbarButtonLabel']), 1))
          : (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              class: "btn-primary",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeDropdown && _ctx.closeDropdown(...args)))
            }, _toDisplayString(_ctx.pageTexts['hotelPageGeneralNavigationButtonSave']), 1))
      ])
    ]),
    _: 1
  }, 8, ["isLocked", "onIsLockedFunction"]))
}